import React from 'react';
import { Helmet } from 'react-helmet';

const GlobalSEO = () => {
  const siteUrl = 'https://www.finclify.com';
  const siteName = 'Finclify - Finance Tools & Calculators';
  
  // Organization structured data
  const organizationStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteName,
    url: siteUrl,
    logo: `${siteUrl}/logo512.svg`,
    description: 'Free financial planning tools and calculators for smart investments. Calculate EMI, plan investments, compare loans and credit cards.',
    sameAs: [
      // Add social media links here when available
      // 'https://www.facebook.com/finclify',
      // 'https://twitter.com/finclify',
      // 'https://www.linkedin.com/company/finclify'
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      url: `${siteUrl}/contact`
    }
  };
  
  // Website structured data
  const websiteStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteName,
    url: siteUrl,
    description: 'Free financial planning tools and calculators for smart investments',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/blog?search={search_term_string}`
      },
      'query-input': 'required name=search_term_string'
    }
  };
  
  // FinancialService structured data
  const financialServiceStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    name: siteName,
    url: siteUrl,
    description: 'Free online financial calculators and tools for EMI calculation, investment planning, tax calculation, and financial product comparison',
    serviceType: [
      'EMI Calculator',
      'Home Loan Calculator',
      'Tax Calculator',
      'SIP Calculator',
      'Credit Card Comparison',
      'Loan Comparison',
      'Insurance Comparison'
    ],
    areaServed: {
      '@type': 'Country',
      name: 'India'
    }
  };

  return (
    <Helmet>
      {/* Organization Structured Data */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructuredData) }}
      />
      
      {/* Website Structured Data */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteStructuredData) }}
      />
      
      {/* Financial Service Structured Data */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(financialServiceStructuredData) }}
      />
    </Helmet>
  );
};

export default GlobalSEO;
